import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/apple-app-store-button.svg'
import _imports_1 from '@/assets/icons/google-play-store-button.svg'


const _hoisted_1 = { class: "grid grid-cols-1 w-full gap-6" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "flex flex-col md:flex-row items-start gap-4" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 0,
  class: "pt-6"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "flex flex-row items-center pt-4" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 1 }

import { computed, ref } from 'vue';
import SectionPanel from '@/components/SectionPanel/SectionPanel.vue';
import { RichText, Field } from '@sitecore-jss/sitecore-jss-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TrackPatrol',
  props: {
    trackYourPatrolTitle: {},
    trackYourPatrolDescription: {},
    appDownloadDescription: {},
    appleDownloadLink: {},
    googleDownloadLink: {},
    showTrackingNumber: { type: Boolean },
    trackingNumber: {},
    notes: {},
    greyBg: {}
  },
  setup(__props: any) {

const props = __props;

const localTrackingNumber = ref<string>(props.trackingNumber ?? '');
const buttonText = ref<string>('Copy number');
const isCopied = ref(false);
const buttonIcon = computed(() =>
  isCopied.value
    ? new URL('@/assets/icons/green-success-icon.svg', import.meta.url).href
    : new URL('@/assets/icons/copy-icon.svg', import.meta.url).href
);

const copyTrackingNumber = async () => {
  try {
    await navigator.clipboard.writeText(localTrackingNumber.value);
    buttonText.value = 'Copied';
    isCopied.value = true;
    setTimeout(() => {
      buttonText.value = 'Copy number';
      isCopied.value = false;
    }, 2000);
  } catch (err) {
    console.error('Failed to copy: ', err);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createBlock(SectionPanel, {
    greyBg: _ctx.greyBg,
    title: { value: _ctx.trackYourPatrolTitle }
  }, {
    sectionPanelContent: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", {
          class: "text-base text-racq-med-grey",
          innerHTML: _ctx.trackYourPatrolDescription
        }, null, 8, _hoisted_2),
        (_ctx.showTrackingNumber)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[0] || (_cache[0] = _createElementVNode("label", {
                for: "tracking-number",
                class: "mb-1 formkit-label block text-input-label w-auto md:pe-8"
              }, " Tracking number ", -1)),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_FormKit, {
                  id: "tracking-number",
                  ref: "trackingNumber",
                  modelValue: _ctx.trackingNumber,
                  type: "text",
                  outerClass: "mb-0 sm:w-full md:w-[240px] !opacity-100 text-racq-med-grey",
                  name: "tracking-number",
                  innerClass: "w-full !bg-racq-anti-flash-white",
                  disabled: true
                }, null, 8, ["modelValue"]),
                _createElementVNode("button", {
                  type: "button",
                  class: "cta-card-button px-3 py-2 text-base btn-md btn btn-secondary w-full md:w-auto",
                  onClick: _withModifiers(copyTrackingNumber, ["stop","prevent"])
                }, [
                  _createElementVNode("img", {
                    src: buttonIcon.value,
                    alt: isCopied.value ? 'success icon' : 'copy icon',
                    role: "img",
                    class: "inline-block h-4 w-4"
                  }, null, 8, _hoisted_5),
                  _createTextVNode(" " + _toDisplayString(buttonText.value), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.appDownloadDescription)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", { innerHTML: _ctx.appDownloadDescription }, null, 8, _hoisted_7)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (_ctx.appleDownloadLink)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _ctx.appleDownloadLink,
              target: "_blank",
              class: "inline-block mr-4"
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "apple app store icon",
                class: "inline-block"
              }, null, -1)
            ]), 8, _hoisted_9))
          : _createCommentVNode("", true),
        (_ctx.googleDownloadLink)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: _ctx.googleDownloadLink,
              target: "_blank",
              class: "inline-block"
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "google play store icon",
                class: "inline-block"
              }, null, -1)
            ]), 8, _hoisted_10))
          : _createCommentVNode("", true)
      ]),
      (_ctx.notes)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_unref(RichText), {
              field: { value: _ctx.notes },
              class: "text-racq-dark-grey text-base-bold"
            }, null, 8, ["field"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["greyBg", "title"]))
}
}

})